import { $ } from './element';

export class ScreenSize {
    private static mobileBreakpoint = 768;
    private static desktopBreakpoint = 960;
    private static windowOffset = $('body').offset();

    public static switchOn(): void {
        window.addEventListener('resize', _ => {
            this.windowOffset = $('body').offset();
        });
    }

    public static getDeviceWidth(): number {
        return window.screen.width;
    }

    public static getWindowWidth(): number {
        return this.windowOffset.width;
    }

    public static getWindowHeight(): number {
        return this.windowOffset.height;
    }

    public static isMobile() {
        return this.getWindowWidth() <= this.mobileBreakpoint;
    }

    public static isDesktop() {
        return this.getWindowWidth() > this.desktopBreakpoint;
    }
}
ScreenSize.switchOn();
